import AdvancedSearchContainer from './AdvancedSearchContainer';
import ProjectProvider from '../../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class AdvancedSearch extends Component {

  render() {

    const { project, data, graph, entitlements, ontologies } = this.props;

    return (
      <ProjectProvider value={this.props.data}>
        <AdvancedSearchContainer
          entitlements={entitlements}
          data={data}
          project={project}
          skosXL={data.skosXL}
          projectLang={data.projectLang}
          graph={graph}
          ontologies={ontologies}
          defaultLang={data.defaultLang} />
      </ProjectProvider>
    );
  }
}

AdvancedSearch.propTypes = {
  entitlements: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  graph: PropTypes.string.isRequired,
  ontologies: PropTypes.array,
  project: PropTypes.string.isRequired
};

export default AdvancedSearch;
